import PropTypes from "prop-types"
import React from "react"
import {Table} from "semantic-ui-react"

const ProductTechnicalTable = ( {product} ) => {
	return (
		<div className="pt4">
			<h4>{translate("Details")}</h4>
			<Table>
				<Table.Body>

					{product.quantities[0] &&
					<Table.Row key={product.quantities[0].map_desc_id}>
						<Table.Cell>
							<label>
								{translate(product.quantities[0].des)}
							</label>
						</Table.Cell>
						<Table.Cell textAlign={"right"}>
							<b> {product.quantities[0].multi} {translate(product.baseUnitDisplayName)}</b>
						</Table.Cell>
					</Table.Row>
					}

					{product.quantities[1] &&
					<tr key={product.quantities[1].map_desc_id}>
						<Table.Cell>
							<label>
								{product.quantities[1].des}
							</label>
						</Table.Cell>
						<Table.Cell textAlign={"right"}>
							<b>{product.quantities[1].multi } {translate(product.baseUnitDisplayName)}</b>
						</Table.Cell>
					</tr>
					}
					
					{product.extraValue.groesse &&
						<tr key={product.quantities[1].map_desc_id}>
							<Table.Cell>
								<label>
									{translate("Maße")}
								</label>
							</Table.Cell>
							<Table.Cell textAlign={"right"}>
								<b>{product.extraValue.groesse}</b>
							</Table.Cell>
						</tr>
					}

					{product.extraValue.unterVE &&
						<tr key={product.quantities[1].map_desc_id}>
							<Table.Cell>
								<label>
									{translate("Unterverpackung")}
								</label>
							</Table.Cell>
							<Table.Cell textAlign={"right"}>
								<b>{product.extraValue.unterVE}</b>
							</Table.Cell>
						</tr>
					}
					
					{product.barcode && <tr>
						<Table.Cell>
							<label>
								EAN
							</label>
						</Table.Cell>
						<Table.Cell textAlign={"right"}>
							<b>  {product.barcode}</b>
						</Table.Cell>
					</tr>}

				</Table.Body>
			</Table>
		</div>
	)
}

ProductTechnicalTable.propTypes = {
	product: PropTypes.object
}


export default ProductTechnicalTable


// WEBPACK FOOTER //
// ./src/theme/lucht-test/components/Product/ProductTechnicalTable.js